import { OnDestroy } from '@angular/core';
import { takeUntilDestroy } from 'take-until-destroy';
import * as i0 from "@angular/core";
import * as i1 from "./patient.account.preferences.proxy";
import * as i2 from "./auth-provider.service";
var PatientAccountPreferencesService = /** @class */ (function () {
    function PatientAccountPreferencesService(patientAccountPreferencesProxy, authProviderService) {
        this.patientAccountPreferencesProxy = patientAccountPreferencesProxy;
        this.authProviderService = authProviderService;
    }
    PatientAccountPreferencesService.prototype.ngOnDestroy = function () { };
    PatientAccountPreferencesService.prototype.setDefaultAccountLanguage = function (languageKey) {
        var _this = this;
        this.patientAccountPreferencesProxy.setDefaultAccountLanguage(languageKey)
            .pipe(takeUntilDestroy(this))
            .subscribe(function () {
            _this.authProviderService.setAccountPreference(languageKey);
        });
    };
    PatientAccountPreferencesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PatientAccountPreferencesService_Factory() { return new PatientAccountPreferencesService(i0.ɵɵinject(i1.PatientAccountPreferencesProxy), i0.ɵɵinject(i2.AuthProviderService)); }, token: PatientAccountPreferencesService, providedIn: "root" });
    return PatientAccountPreferencesService;
}());
export { PatientAccountPreferencesService };
